import React from 'react';
import { createRoot } from 'react-dom/client';
import { KioskApp } from './KioskApp';

const stylesheet = document.createElement('style');
stylesheet.textContent = `
  :root { background: #000; color: #fff; font-family: Arial, sans-serif; }
  .kiosk { width: 100%; height: 100%; min-height: 100dvh; overflow: hidden; background: #000; display: grid; place-items: center; }
  .kiosk__video { width: 100%; height: 100%; object-fit: contain; background: #000; }
  .kiosk__status { text-align: center; color: #fff; padding: 2rem; }
  .kiosk__status p { font-size: clamp(1.25rem, 2vw, 2rem); margin: 0 0 .75rem; }
  .kiosk__status small { color: #ccc; }
`;
document.head.appendChild(stylesheet);

const root = document.getElementById('root');

if (!root) {
  throw new Error('Elemento raiz da aplicação não encontrado.');
}

createRoot(root).render(<KioskApp />);
